import { REDIRECT_URL_QUERY_KEY } from "@/features/auth/constant/login";
import { AppRoutes } from "@/routes/config";
import { logout } from "@/utils/logout";
import { getSessionIdentity } from "@/utils/token";
import { createUrlWithParams, getSafeRedirectURL } from "@/utils/url";

type TRedirectToLoginOptions = {
  /**
   * Clear the auth token (and related cookies) before redirecting.
   */
  clearToken?: boolean;
};

export const redirectToLogin = async (options?: TRedirectToLoginOptions) => {
  // Read the identity from the access token claims before it is cleared below
  const { email, externalId } = getSessionIdentity();
  // Clear the token before leaving so the login page starts from a clean session
  if (options?.clearToken) {
    await logout();
  }

  const params = new URLSearchParams(location.search);
  const redirectUrl = params.get(REDIRECT_URL_QUERY_KEY);

  const oldUrl = getSafeRedirectURL(redirectUrl, `${location.pathname}${location.search}`);
  let targetUrl = "";
  if (externalId && email) {
    targetUrl = createUrlWithParams(AppRoutes.loginCredentials, { redirectUrl: oldUrl, email, externalId });
  } else {
    targetUrl = createUrlWithParams(AppRoutes.login, { redirectUrl: oldUrl, externalId });
  }
  location.href = targetUrl;
};
